<app-view-participants class="dashboard-filter" *ngIf="rootService.openViewParticipant"></app-view-participants>
<div class="batch-header flex justify-space-between">
    <div class="admin-header">
        <h5 class="heading">Current Batch Alert</h5>
    </div>
    
    <div class="filter flex" >
        <button mat-button color="primary" class="btn-filter" title="Filters" (click)="openFilter()">
            <span *ngIf="!batchAlertService.filteronCurrentBatchAlertApplied">
            <f-icon icon-config='{"iconName": "filter", "iconType": "light", "iconSize": "s"}'></f-icon>
          </span>
          <span *ngIf="batchAlertService.filteronCurrentBatchAlertApplied">
            <f-icon icon-config='{"iconName": "filter", "iconType": "solid", "iconSize": "s"}'></f-icon>
          </span>

          <span>Filters</span>
        </button>
        <button mat-button color="primary" title="Clear Filter" class="clear-filter" (click)="clearFilter()" [disabled]="!batchAlertService.filteronCurrentBatchAlertApplied">
            <span>Clear Filter</span>
        </button>
    </div>
</div>


<section class="error-wrapper" *ngIf="batchAlertService.currentbatchAlertErrMsg">
    <f-alert variant="error">
        <p>
            There was problem loading the data. <a  href="javascript:void('0')" (click)="batchAlertService.getDataForCurrentBatchAlert(batchAlertService.clientId)"class="btn-alert">Try again.</a>
        </p>
    </f-alert>

</section>

<section class="error-wrapper" *ngIf="batchAlertService.deleteBatchAlertMsgSuccess">
    <f-alert variant="success">
        <p> Batch alert deleted successfully. Batch ID: {{batchAlertService.deletedBatchAlertDetail?.externalRefId}}, Num of Records: {{batchAlertService.deletedBatchAlertDetail?.alertCount}} </p>
    </f-alert>
</section>

<section class="error-wrapper" *ngIf="batchAlertService.deleteBatchAlertMsgFail">
    <f-alert variant="error">
        <p>There was a problem deleting the batch alert. <button (click)="deleteAlertModal()" class="btn-alert">Try again</button></p>
    </f-alert>
</section>

<div class="current-batch-table">
    <app-alight-table class="current-table" [dataSource]="batchAlertService.currentBatchAlertData" [totalRecords]="totalRecords" [gridColumns]="batchAlertService.currentColumns"
    [tableName]="'currentTable'" [rowPerPage]="10" (rowSelection)="rowSelection($event)"  [selectedRow]="selectedRow"
    [isShowButtons]="false"></app-alight-table>
    
    <div class="footer-controls">
        <div class="footer-controls-left">
            <f-button text="Delete alert" title="Delete alert" type="button" variant="destructive" [ngClass]="{disableBtn: batchAlertService.currentBatchSelectedRow ? false : true}" [disabled]="batchAlertService.currentBatchSelectedRow ? false : true" (click)="deleteAlertModal()">
            </f-button>
            <f-button text="View participants" title="View participants" type="button" variant="progressive" [ngClass]="{disableBtn: batchAlertService.currentBatchSelectedRow ? false : true}" [disabled]="batchAlertService.currentBatchSelectedRow ? false : true" (click)="viewParticipantModal()">
            </f-button>
        </div>
    </div>
</div>  